module.exports = __webpack_public_path__ + "media/Loops Perc.ef5cb496.wav";